import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  Card,
  CardMedia,
  CardActions,
  Button,
  Typography,
  CardContent,
} from "@mui/material";
import Records from "./CouponsRecord.json";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "black" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "black" }}
      onClick={onClick}
    />
  );
}

const HomeCouponCarousel = () => {
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 2,
    initialSlide: 0,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div>
      <h3>Top Coupons</h3>
      <Slider {...settings}>
        {Records.map((record) => {
          return (
            <div>
              <Card
                sx={{
                  maxWidth: 345,
                  marginLeft: "20px",
                  marginBottom: "30px",
                }}
              >
                <CardMedia
                  sx={{ height: 200 }}
                  image={record.BrandThumbnail}
                  Offer={record.Offer}
                />
                <CardContent sx={{ height: 80 }}>
                  <Typography gutterBottom variant="h7" component="div">
                    <b>
                      {record.Offer.length > 45
                        ? record.Offer.substring(0, 45) + ".."
                        : record.Offer}
                    </b>
                  </Typography>
                  <Typography variant="h8" color="text.secondary">
                    {record.OfferDetails.length > 60
                      ? record.OfferDetails.substring(0, 60) + "..."
                      : record.OfferDetails}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button size="small">Learn More</Button>
                </CardActions>
              </Card>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default HomeCouponCarousel;
